const Permissions = {
    genome_portal: 'GenomePortal',
    admin_screen: 'AdminScreen',
};

export default Permissions;
